import { render } from "./StateSanierungDach.vue?vue&type=template&id=172adfd8"
import script from "./StateSanierungDach.vue?vue&type=script&lang=js"
export * from "./StateSanierungDach.vue?vue&type=script&lang=js"

import exportComponent from "E:\\vattenfall\\vattenfall-klickstrecke\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__